<template>
  <div style="width: 100%;">
    <v-container fluid>
      <v-row>
        <v-col class='d-flex flex-column' v-if="data">
          <div class="d-flex flex-row align-center">
            <v-btn text @click="()=>{$router.go(-1)}">
              <v-icon dark>mdi-arrow-left</v-icon>
            </v-btn>
            <h1>{{singular}} #{{ data.id }}</h1>
            <v-chip class="ml-4" :color="utils.getStocktakingEventStatusColor(data.status)">{{utils.parseStocktakingEventStatus(data.status)}}</v-chip>
            <v-progress-circular
              indeterminate
              color="green"
              v-if="loader"
              style="margin-left: 10px;"
            ></v-progress-circular>
            <v-btn v-if="data.status===0 || data.status===3" class="ml-2" color="info" @click="startEvent">Start Event</v-btn>
            <v-btn v-if="data.status===1" class="ml-2" color="info" @click="pauseEvent">Pause Event</v-btn>
            <v-btn v-if="data.status===1 || data.status===3" class="ml-2" color="info" @click="endEvent">End Event</v-btn>
          </div>
          <h5>Created at: {{ utils.formatDate(data.createdAt) }} {{ utils.formatTime(data.createdAt) }}</h5>
          <h5 v-if="data.startedAt">Started at: {{ utils.formatDate(data.startedAt) }} {{ utils.formatTime(data.startedAt) }}</h5>
          <h5 v-if="data.endedAt">Ended at: {{ utils.formatDate(data.endedAt) }} {{ utils.formatTime(data.endedAt) }}</h5>
          <div style="width: 100%;">
            <h2>Notes</h2>
            <v-textarea auto-grow rows="5" width="100%" outlined v-model="data.notes" @change="saveEvent"></v-textarea>
          </div>
          <div v-if="data.status === 2">
            <h2>Reports</h2>
             <dynamicButtonContainer @res="getPrintResponse" v-if="getGlobalValue('VEC_PRINT_SYSTEM_CONTAINER_STOCKTAKING_EVENT_DIALOG')" :containerId="`${getGlobalValue('VEC_PRINT_SYSTEM_CONTAINER_STOCKTAKING_EVENT_DIALOG')}`" :data="{data}"/>
          </div>
          <span>
            <v-switch label="Deduct Flagged Counts" v-model="deductFlagged"/>
          </span>
          <div>
            <h2>Product Counts Per Location</h2>
            <span class="d-flex flex-column">
              <v-card outlined>
                <v-card-text>
                  <v-data-table
                      :headers="headers2"
                      :items="data.sessionCounts"
                      :search="tableSearch"
                      @click:row="lineRowClick"
                      @mousedown:row="lineRowMiddleClick"
                  >
                    <template v-slot:top>
                      <v-text-field
                          v-model="tableSearch"
                          label="Search..."
                      ></v-text-field>
                    </template>
                    <template v-slot:item.location="{ item }">
                      <span>{{lookupBranch(item.locationId)}}</span>
                    </template>
                    <template v-slot:item.productId="{ item }">
                      <span>PL{{item.productId}}</span>
                    </template>
                    <template v-slot:item.Product.name="{ item }">
                      <span>{{item.Product?.name || 'Product '+item.productId}}</span>
                    </template>
                    <template v-slot:item.sku="{ item }">
                      <span>{{item.Product?.sku||''}}</span>
                    </template>
                    <template v-slot:item.counted="{ item }">
                      <span>{{deductFlagged?utils.pff(item.countExcludeFlagged):utils.pff(item.count)}}</span>
                    </template>
                    <template v-slot:item.expected="{ item }">
                      <span>{{totalSystemQuantities(item.pointInTimeSystemQuantities)}}</span>
                    </template>
                    <template v-slot:item.difference="{ item }">
                      <span>{{utils.pff(utils.pff(item.count)-(totalSystemQuantities(item.pointInTimeSystemQuantities)))}}</span>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <span>
                        <v-btn x-small :color="item.appliedChange?'warning':'info'" fab @click="openEventLineActionDialog($event, item)"><v-icon>mdi-transfer</v-icon></v-btn>
                      </span>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </span>
          </div>
        </v-col>
        <v-col cols="4">
          <h2>Individual Counts</h2>
          <span class="d-flex flex-column">
            <v-card outlined>
              <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="data.ProductCounts"
                    :search="tableSearch"
                >
                  <template v-slot:top>
                    <v-text-field
                        v-model="tableSearch"
                        label="Search..."
                    ></v-text-field>
                  </template>
                  <template v-slot:item.productId="{ item }">
                      <span>PL{{item.productId}}</span>
                    </template>
                  <template v-slot:item.location="{ item }">
                    <span>{{lookupBranch(item.metadata.location)}}</span>
                  </template>
                  <template v-slot:item.user="{ item }">
                    <span>{{lookupUsername(item.createdBy)}}</span>
                  </template>
                  <template v-slot:item.createdAt="{ item }">
                    <span>{{utils.formatDate(item.createdAt, 'withTime')}}</span>
                  </template>
                  <template v-slot:item.flagged="{ item }">
                    <span>{{item.metadata.flagged?'🔴':"-"}}</span>
                  </template>
                  <template v-slot:item.notes="{ item }">
                    <pre>{{item.notes}}</pre>
                  </template>
                  <template v-slot:item.counted="{ item }">
                    <span>{{utils.pff(item.count)}}</span>
                  </template>
                  <template v-slot:item.expected="{ item }">
                    <span>{{totalSystemQuantities(item.pointInTimeSystemQuantities)}}</span>
                  </template>
                  <template v-slot:item.difference="{ item }">
                    <span>{{utils.pff(utils.pff(item.count)-(totalSystemQuantities(item.pointInTimeSystemQuantities)))}}</span>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
        v-model="eventLineActionDialog.isOpen"
        width="1000px"
    >
      <v-card v-if="eventLineActionDialog.product">
        <v-card-title class="text-h5">{{eventLineActionDialog.product.name}} (ID: {{eventLineActionDialog.item.productId}})</v-card-title>
        <v-card-subtitle class="d-flex flex-column">
          <span v-if="eventLineActionDialog.product.sku">SKU: {{eventLineActionDialog.product.sku}}</span>
          <span>Location: {{lookupBranch(eventLineActionDialog.item.locationId)}}</span>
        </v-card-subtitle>
        <v-card-subtitle>
          <v-btn small color="info" :to="`/products/view/${eventLineActionDialog.item.productId}`">View Product</v-btn>
        </v-card-subtitle>
        <v-card-text class="d-flex flex-column">
          <span class="d-flex flex-column" v-if="data.status===2 && !eventLineActionDialog.item.appliedChange">
            <h3>Total Live Stock: {{eventLineActionDialog.totalQty}}</h3>
            <v-row class="my-2">
              <v-col class="py-0" v-for="(loc, l) of Object.keys(eventLineActionDialog.qtys)" :key="l" cols="3">
                <span><b>{{lookupBranch(loc.split('loc-')[1])}} ({{eventLineActionDialog.qtys[loc].manageStock?'Managed':'Unmanaged'}}): </b>{{eventLineActionDialog.qtys[loc].qty}}</span>
              </v-col>
            </v-row>
          </span>
          <span class="mt-2 d-flex flex-row" style="gap: 4px;" v-if="data.status===2 && !eventLineActionDialog.item.appliedChange">
            <v-select dense outlined v-model="eventLineActionDialog.data.action" hide-details :items="eventLineActionDialog.actions" label="Action"/>
            <v-select :disabled="eventLineActionDialog.data.action==='none'" dense outlined v-model="eventLineActionDialog.data.location" hide-details :items="getBranches" item-text="name" item-value="id" label="Apply change to"/>
            <v-text-field :disabled="eventLineActionDialog.data.action==='none'" dense outlined v-model="eventLineActionDialog.data.quantity" hide-details label="QTY"/>
          </span>
          <span class="d-flex flex-column" v-if="eventLineActionDialog.qtys[`loc-${eventLineActionDialog.data.location}`]?.metadata?.stockTakingLog">
            <span>Last Stocktaking Update: <b>{{parseLastStockTakingUpdate().update}}</b></span>
            <span>Resync Period Active From: <b>{{parseLastStockTakingUpdate().resync}}</b></span>
          </span>
          <span class="green--text" v-if="data.status===2 && eventLineActionDialog.item.appliedChange">
            Actions were applied at {{utils.formatDate(eventLineActionDialog.item.appliedChange.timeStamp, 'withTime')}}
          </span>
          <span class="mt-2 d-flex flex-row" style="gap: 4px;" v-if="data.status===2 && eventLineActionDialog.item.appliedChange">
            <v-select disabled dense outlined v-model="eventLineActionDialog.item.appliedChange.action" hide-details :items="eventLineActionDialog.actions" label="Action"/>
            <v-select disabled dense outlined v-model="eventLineActionDialog.item.appliedChange.location" hide-details :items="getBranches" item-text="name" item-value="id" label="Apply change to"/>
            <v-text-field disabled dense outlined v-model="eventLineActionDialog.item.appliedChange.quantity" hide-details label="QTY"/>
          </span>
          <span class="red--text" v-if="!eventLineActionDialog.qtys[`loc-${eventLineActionDialog.data.location}`].manageStock">
            Managed Stock for the selected location of this product is currently <b>Unmanaged</b>. No changes will be made if applied.
          </span>
          <span>
            Original count of <b>{{deductFlagged?utils.pff(eventLineActionDialog.item.countExcludeFlagged):utils.pff(eventLineActionDialog.item.count)}}</b> in <b>{{lookupBranch(eventLineActionDialog.item.locationId)}}</b>
          </span>
        </v-card-text>
        <v-card-text>
          <h2>User Counts</h2>
          <span v-for="(user, u) of eventLineActionDialog.item.UserCounts" :key="u" class="d-flex flex-column">
            <span>{{lookupUsername(user.userId)}}: <b>{{deductFlagged?utils.pff(user.countExcludeFlagged):utils.pff(user.count)}}</b></span>
          </span>
        </v-card-text>
        <v-card-text>
          <div>
            <h2>Individual Counts</h2>
            <span class="d-flex flex-column">
              <span>
                <h3>Filter By User</h3>
                <v-autocomplete dense outlined label="User" clearable v-model="eventLineActionDialog.filterUser" :items="eventLineActionDialog.item.UserCounts" item-value="userId" :item-text="($event) => lookupUsername($event.userId)" @change="filterEventLineActionDialogByUser"/>
              </span>
              <v-card outlined>
                <v-card-text>
                  <v-data-table
                      :headers="headers"
                      :items="eventLineActionDialog.visibleCounts"
                      :search="tableSearch"
                  >
                    <template v-slot:top>
                      <v-text-field
                          v-model="tableSearch"
                          label="Search..."
                      ></v-text-field>
                    </template>
                    <template v-slot:item.productId="{ item }">
                      <span>PL{{item.productId}}</span>
                    </template>
                    <template v-slot:item.location="{ item }">
                      <span>{{lookupBranch(item.metadata.location)}}</span>
                    </template>
                    <template v-slot:item.user="{ item }">
                      <span>{{lookupUsername(item.createdBy)}}</span>
                    </template>
                    <template v-slot:item.createdAt="{ item }">
                      <span>{{utils.formatDate(item.createdAt, 'withTime')}}</span>
                    </template>
                    <template v-slot:item.flagged="{ item }">
                      <span>{{item.metadata.flagged?'🔴':"-"}}</span>
                    </template>
                    <template v-slot:item.notes="{ item }">
                      <pre>{{item.notes}}</pre>
                    </template>
                    <template v-slot:item.counted="{ item }">
                      <span>{{utils.pff(item.count)}}</span>
                    </template>
                    <template v-slot:item.expected="{ item }">
                      <span>{{totalSystemQuantities(item.pointInTimeSystemQuantities)}}</span>
                    </template>
                    <template v-slot:item.difference="{ item }">
                      <span>{{utils.pff(utils.pff(item.count)-(totalSystemQuantities(item.pointInTimeSystemQuantities)))}}</span>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </span>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="data.status===2 && !eventLineActionDialog.item.appliedChange" :loading="eventLineActionDialog.loader" color="success" small @click="applyEventLineAction">
            Apply
          </v-btn>
          <v-btn color="error" small @click="closeEventLineActionDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackObj.state" :timeout="3000" :color="snackObj.color">
      {{ snackObj.text }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snackObj.state = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
  import axios from 'axios';
  import {mapGetters} from "vuex";
  import helpers from "../../plugins/helpers";
  // import dynamicButtonContainer from "../../components/dynamicButtonContainer.vue";
  import utils from "../../plugins/helpers"
// import lookup from 'socket.io-client';
  export default {
    components: {
      // dynamicButtonContainer
    },
    data () {
      return {
        utils: utils,
        deleteDialog: false,
        deleteConfirmed: true,
        loader: true,

        snackObj: {
          state: false,
          color: '',
          text: ''
        },

        headers: [
          { text: 'PL', align: 'start', sortable: true, value:'productId'},
          { text: 'Location', value: 'location', sortable: false },
          { text: 'Name', sortable: true, value: 'Product.name'},
          { text: 'SKU', sortable: true, value: 'Product.sku'},
          { text: 'Counted By', value: 'user', sortable: false },
          { text: 'Reported Count', value: 'counted' },
          { text: 'Expected Count', value: 'expected', sortable: false },
          { text: 'Difference', sortable: false, value: 'difference' },
          { text: 'Notes', value: 'notes', sortable: false },
          { text: 'Flagged', value: 'flagged', sortable: false },
          { text: 'Counted At', value: 'createdAt' }
        ],
        tableSearch: '',

        headers2: [
          { text: 'PL', align: 'start', sortable: true, value:'productId'},
          { text: 'Location', value: 'location', sortable: false },
          { text: 'Name', sortable: true, value: 'Product.name'},
          { text: 'SKU', sortable: true, value: 'Product.sku'},
          { text: 'Reported Count', value: 'counted' },
          { text: 'Expected Count', value: 'expected', sortable: false },
          { text: 'Difference', sortable: false, value: 'difference' },
          { text: 'Actions', value: 'actions' },
        ],

        eventLineActionDialog:{
          isOpen:false,
          loader: false,
          data: {
            action: "none",
            location: null,
            quantity: 0
          },
          product: null,
          visibleCounts: [],
          filterUser: null,
          qtys: {
          },
          totalQty: 0,
          item: null,
          actions: [{text: "No change", value: "none"}, {text: "Add to Current Stock", value: "add"}, {text: "Overwrite existing stock", value: "overwrite"}]
        },
        deductFlagged: false,

        max25chars: v => v.length <= 25 || 'Input too long!',
        editMode: false,
        data: {},
        singular: "Stocktaking Event",
        singularLower: "stocktakingEvent",
        plural: "Stocktaking Events",
        pluralLower: "stocktakingEvents",
        isEditable: false,
      }
    },
    async mounted(){
        try {
          let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`)
          if(res.data.error) throw res.data.error
          
          this.data = res.data.data

          console.log(this.data)

        } catch (error) {
          console.error(error)
          this.snack(error.msg || error.msg?.message || error, "error");
        } finally {
          this.loader = false;
        }
    },
    computed: {
      ...mapGetters(['getEndpoint', "isAllowed", 'lookupUsername', 'lookupBranch', 'getBranches', 'getGlobalValue', 'getUserCache'])
    },
    methods: {
      snack(text, color=""){
        this.snackObj.text = text;
        this.snackObj.state = true;
        this.snackObj.color = color;
      },
      async getPrintResponse(){
        console.log("Print Response")
      },
      totalSystemQuantities(arr){
        return utils.pff(arr.reduce((acc,x)=>acc+parseInt(x.quantity),0))
      },
      async saveEvent(){
        try {
          this.loader = true;
          let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/saveEvent/${this.$route.params.id}`, this.data)
          if(res.data.error) throw res.data.error

          this.snack(`${this.singular} Event Saved.`, "success");
          this.isEditable = false;
        } catch (error) {
          console.error(error)
          this.snack(error.msg || error.msg?.message || error, "error");
        } finally {
          this.loader = false;
        }
      },
      async startEvent(){
        try {
          this.loader = true;
          let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/startEvent/${this.$route.params.id}`)
          if(res.data.error) throw res.data.error
          this.data.status = res.data.status

          this.snack(`${this.singular} Event Started.`, "success");
          this.isEditable = false;
        } catch (error) {
          console.error(error)
          this.snack(error.msg || error.msg?.message || error, "error");
        } finally {
          this.loader = false;
        }
      },
      async pauseEvent(){
        try {
          this.loader = true;
          let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/pauseEvent/${this.$route.params.id}`)
          if(res.data.error) throw res.data.error
          this.data.status = res.data.status

          this.snack(`${this.singular} Event Started.`, "success");
          this.isEditable = false;
        } catch (error) {
          console.error(error)
          this.snack(error.msg || error.msg?.message || error, "error");
        } finally {
          this.loader = false;
        }
      },
      async endEvent(){
        try {
          this.loader = true;
          let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/endEvent/${this.$route.params.id}`)
          if(res.data.error) throw res.data.error
          this.data.status = res.data.status

          this.snack(`${this.singular} Event Ended.`, "success");
          this.isEditable = false;
        } catch (error) {
          console.error(error)
          this.snack(error.msg || error.msg?.message || error, "error");
        } finally {
          this.loader = false;
        }
      },
      async deleteData(){
        try {
          this.loader = true
          let res = await axios.delete(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`)
          if(res.data.error) throw res.data.error

          this.snack(this.singular+" Deleted 🎉", "success");
          await this.$router.push({ path: `/${this.pluralLower}`})
        } catch (error) {
          console.error(error)
          this.snack(error.msg || error.msg?.message || error, "error");
        } finally {
          this.loader = false;
        }
      },
      async openEventLineActionDialog(e, item){
        try {
          e.stopPropagation();

          let res = await axios.get(`${this.getEndpoint}/api/products/${item.productId}`)
          if(res.data.error) throw res.data.error
          this.eventLineActionDialog.product = res.data.data

          let total = 0;

          for(let plj of this.eventLineActionDialog.product.ProductLocationJoins){
            total+=helpers.pff(plj.quantity);

            this.eventLineActionDialog.qtys[`loc-${plj.locationId}`] = {manageStock: plj.manageStock, qty: helpers.pff(plj.quantity), metadata: plj.metadata};
          }
          this.eventLineActionDialog.totalQty = total;

          this.eventLineActionDialog.visibleCounts = item.ProductCounts;
          if(this.deductFlagged){
            this.eventLineActionDialog.visibleCounts = this.eventLineActionDialog.visibleCounts.filter(x => !x.metadata.flagged)
          }

          this.eventLineActionDialog.item = item;
          this.eventLineActionDialog.data = {
            action: "none",
            location: item.locationId,
            quantity: this.deductFlagged?utils.pff(item.countExcludeFlagged):utils.pff(item.count)
          }
          this.eventLineActionDialog.isOpen = true;
        } catch (error) {
          console.error(error)
          this.snack(error.msg || error.msg?.message || error, "error");
        } finally {
          this.loader = false;
        }
      },
      closeEventLineActionDialog(){
        this.eventLineActionDialog.isOpen = false;
        this.eventLineActionDialog.data = {
          action: "none",
          location: null,
          quantity: 0
        }
        this.eventLineActionDialog.product = null;
        this.eventLineActionDialog.item = null;
      },
      async applyEventLineAction(){
        try {
          this.eventLineActionDialog.loader = true;
          let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/applyLineAction/${this.$route.params.id}`, {data: this.eventLineActionDialog.data, item: this.eventLineActionDialog.item})
          if(res.data.error) throw res.data.error

          let pc = res.data.data.ProductCounts.find(x => x.productId===this.eventLineActionDialog.item.productId && x.metadata.location===this.eventLineActionDialog.item.locationId)
          if(pc){
            this.eventLineActionDialog.item.appliedChange = pc.metadata?.appliedChange;
          }

          this.snack(`Action Applied.`, "success");
          this.closeEventLineActionDialog();

          this.isEditable = false;
        } catch (error) {
          console.error(error)
          this.snack(error.msg || error.msg?.message || error, "error");
        } finally {
          this.eventLineActionDialog.loader = false;
        }
      },
      parseLastStockTakingUpdate(){
        let metadata = this.eventLineActionDialog.qtys[`loc-${this.eventLineActionDialog.data.location}`].metadata
        let log = metadata.stockTakingLog
        let last = log.actions[log.actions.length-1];
        return {
          update: `Stocktaking Event #${log.eventId} | ${last.type.toUpperCase()}: ${utils.formatDate(last.date, 'withTime')}`,
          resync: `${utils.formatDate(metadata.stockTakingResync, 'withTime')}`
        }
      },
      getLineRowRoute(item){
        let addon = '';
        if(item.Product.parent){
          addon = `?variation=${item.productId}`;
        }
        return `/products/view/${item.Product.parent?item.Product.parent:item.productId}${addon}`
      },
      lineRowClick(item){
        this.$router.push({ path: this.getLineRowRoute(item)});
      },
      async lineRowMiddleClick(event, row){
        if(!row.item) return;
        row = row.item;

        if (event.button === 1) {
          event.preventDefault();
          this.utils.openInNewTab(this.$router,this.getLineRowRoute(row))
        }
      },
      filterEventLineActionDialogByUser(){
        console.log(this.eventLineActionDialog.filterUser)
        if(this.eventLineActionDialog.filterUser){
          this.eventLineActionDialog.visibleCounts = this.eventLineActionDialog.item.ProductCounts.filter(x => x.createdBy===this.eventLineActionDialog.filterUser);
        }
        else{
          this.eventLineActionDialog.visibleCounts = this.eventLineActionDialog.item.ProductCounts;
        }

        if(this.deductFlagged){
          this.eventLineActionDialog.visibleCounts = this.eventLineActionDialog.visibleCounts.filter(x => !x.metadata.flagged)
        }
      }
    }
  }
</script>
